<script lang="ts" setup>
import { ref } from 'vue'

import RedirectButton from '@/components/RedirectButton/RedirectButton.vue'
import TradingFooter from '@/components/TradingBlock/TradingFooter.vue'

const props = defineProps({ data: Object })

const traderOptions = [
  props?.data?.metatrader_4_dropdown_label,
  props?.data?.metatrader_dropdown_5_label
]
const isDropdownOpen = ref(false)
const selectedTrader = ref(props?.data?.metatrader_4_dropdown_label)

const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value
}

const selectTrader = (trader: string) => {
  isDropdownOpen.value = false
  selectedTrader.value = trader
}
</script>
<template>
  <div class="flex flex-col lg:flex-row">
    <div
      class="flex flex-col lg:justify-start items-center lg:items-start w-full lg:max-w-[346px] mt-10 lg:ml-10"
    >
      <div>
        <img loading="lazy" :src="data?.logo" :alt="data?.logo_alt" />
      </div>
      <div
        class="w-full mt-5 text-base px-[10px] md:px-[0px] lg:w-[310px] lg:h-[145px] -tracking-tightest md:text-center lg:text-start"
      >
        {{ data?.description }}
      </div>
      <div class="flex justify-center w-full my-8 lg:hidden">
        <img
          class="shadow mt4"
          loading="lazy"
          :src="data?.main_image"
          :alt="data?.main_image_alt"
        />
      </div>
      <div class="flex-col justify-between hidden mt-5 mb-10 lg:flex">
        <div class="flex flex-col md:max-w-[310px]">
          <div class="flex flex-col items-start">
            <div class="">{{ data?.mt_dropdown_selector_title }}</div>
            <div class="flex justify-center w-full md:max-w-[310px]">
              <div class="w-full">
                <button
                  class="relative flex justify-start w-full cursor-pointer border-[2px] border-gray-350 leading-5 py-4"
                  type="button"
                  @click="toggleDropdown()"
                >
                  <span class="flex">
                    <span class="ml-[10px] text-base leading-[19px]">{{ selectedTrader }}</span>
                  </span>
                  <span class="absolute flex right-3 top-[22px] fill-black">
                    <img
                      v-if="!isDropdownOpen"
                      alt="dropdown arrow down"
                      loading="lazy"
                      src="/assets/dropdown-arrow-down-black.svg"
                    />
                    <img
                      v-if="isDropdownOpen"
                      alt="dropdown arrow up"
                      loading="lazy"
                      src="/assets/dropdown-arrow-up-black.webp"
                    />
                  </span>
                </button>
                <div
                  :class="{ hidden: !isDropdownOpen }"
                  class="relative z-50 text-sm list-none bg-white divide-y divide-gray-100"
                >
                  <ul class="absolute w-full bg-white shadow-md">
                    <li
                      :class="selectedTrader === traderOptions[0] ? 'bg-gray-100' : ''"
                      class="cursor-pointer"
                      @click="selectTrader(data?.metatrader_4_dropdown_label)"
                    >
                      <div class="flex items-center w-full ml-1 text-sm" role="menuitem">
                        <div
                          class="inline-flex items-center py-4 text-base leading-[19px] ml-[10px]"
                        >
                          {{ data?.metatrader_4_dropdown_label }}
                        </div>
                      </div>
                    </li>
                    <li
                      :class="selectedTrader === traderOptions[1] ? 'bg-gray-100' : ''"
                      class="cursor-pointer"
                      @click="selectTrader(data?.metatrader_dropdown_5_label)"
                    >
                      <div class="flex items-center w-full ml-1 text-sm" role="menuitem">
                        <div
                          class="inline-flex items-center py-4 text-base leading-[19px] ml-[10px]"
                        >
                          {{ data?.metatrader_dropdown_5_label }}
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex gap-2 mt-[20px] relative z-10">
          <RedirectButton
            :href="
              selectedTrader === traderOptions[0]
                ? data?.mt_4_windows_link
                : data?.mt_5_windows_link
            "
            :text="data?.download_windows_button_text"
            type="primary"
            custom-class="!w-auto px-5 flex-shrink-0"
          />
          <RedirectButton
            :href="selectedTrader === traderOptions[0] ? data?.mt4_mac_link : data?.mt5_mac_link"
            :text="data?.download_mac_button_text"
            type="primary"
            custom-class="!w-auto px-5 flex-shrink-0"
          />
        </div>
      </div>
    </div>
    <div class="items-center hidden w-full mt-12 md:justify-center lg:flex lg:ml-18 min-h-[596px]">
      <img class="shadow mt4" loading="lazy" :src="data?.main_image" :alt="data?.main_image_alt" />
    </div>
  </div>
  <TradingFooter
    :titleOne="data?.footer_column_one_title"
    :contentOne="data?.footer_column_one_content"
    :titleTwo="data?.footer_column_two_title"
    :contentTwo="data?.footer_column_two_content"
    :titleThree="data?.footer_column_three_title"
    :contentThree="data?.footer_column_three_content"
    :titleFour="data?.footer_column_four_title"
    :contentFour="data?.footer_column_four_content"
    :footerIconLink="data?.footer_icon"
    :footerIconAlt="data?.footer_icon_alt"
    class="lg:mb-20"
  ></TradingFooter>
</template>
